import { getField, updateField } from "vuex-map-fields";
import interestLoanPayment from "./interestLoanPayment";
import lnamtRpayAnticiInq from "./lnamtRpayAnticiInq";

const getDefaultState = () => {
  return {};
};

const loans = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("interestLoanPayment/resetState");
      commit("lnamtRpayAnticiInq/resetState");
    },
  },
  modules: {
    interestLoanPayment,
    lnamtRpayAnticiInq,
  },
};

export default loans;
